import type { PetitionDetailsPageData } from 'src/app/pages/petitionGamma/details/pageContext';

export type DMs = PetitionDetailsPageData['petition']['primaryDecisionMakerConnection']['nodes'];
export type AllDmResponses = ReadonlyArray<{
	readonly id: string;
	readonly message: string;
	readonly decisionMaker: {
		readonly id: string;
		readonly displayName: string;
	};
}>;

export const MAX_DISPLAYED_DMS_ON_LB_CARD = 3;
export const MAX_DISPLAYED_DM_CARDS_ON_PETITION = 5;

export const PRIMARY_ROLE_KEYWORDS = [
	'president',
	'executive',
	'chair',
	'governor',
	'attorney general',
	'sheriff',
	'judge',
	'mayor',
	'chief',
];

export type SortingMetadata = {
	hasResponse: boolean;
	constituentCount: number;
	isAutoAdded: boolean;
};

export type NormalizedDecisionMaker = {
	id: string;
	displayName: string;
	slug: string | null;
	title: string | null;
	titleStrippedDown: string | null;
	isAutoAdded: boolean;
	location: string | null;
	photoUrl: string | null;
	signersText: string;
	constituentCount: string | null | undefined;
	publiclyVisible: boolean;
	type: string;
	response?: {
		id: string;
		message: string;
	};
};

export type LegislativeBody = {
	title: string;
	location: string | null;
	responsesText?: string;
	displayedDMs: readonly NormalizedDecisionMaker[];
	allDMs: readonly NormalizedDecisionMaker[];
	viewMoreText?: string;
};

export type BuildingBlockDms = Array<
	| { component: 'primary'; componentDm: NormalizedDecisionMaker }
	| {
			component: 'legislativeBody';
			componentDms: readonly NormalizedDecisionMaker[];
			componentAttributes: {
				title: string;
				location: string | null;
				responsesText?: string;
				displayedDMs: readonly NormalizedDecisionMaker[];
				viewMoreText?: string;
			};
	  }
	| {
			component: 'individual';
			componentDm: NormalizedDecisionMaker;
	  }
>;
